import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { useToast } from "../other/Toast";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import {
  addBoid,
  removeBoid,
  setForwardBoid,
  setHasBoid,
  setCreateBoid,
  setCreateMeroShareId,
  setFdpId,
  setFdpIdDesc,
} from "../../redux/boidSlice";
import { setActive } from "../../redux/routerSlice";
import { NextButton, PrevButton } from "./kycSidebar";
import { useTranslation } from "react-i18next";
import { classNames } from "primereact/utils";
import { useForm, Controller, set } from "react-hook-form";
import { DynamicFieldSection } from "./personalDetails";
import { setOrganizationName } from "../../redux/occupationSlice";
import ApiService from "../service/apiService";
import { SaveButton } from "./declerationDetails";
import { InputMask } from "primereact/inputmask";
import { confirmDialog } from "primereact/confirmdialog";
import { KycInfoForPublic } from "../customComponent/KycInfoForPublic";

// const inputTextEditor = (productKey, props, field, onEditorValueChange) => {
//     return <InputText type="text" value={props.rowData[field]} onChange={(e) => onEditorValueChange(productKey, props, e.target.value)} />;
// }

// const codeEditor = (productKey, props, onEditorValueChange) => {
//     return inputTextEditor(productKey, props, 'code', onEditorValueChange);
// }

function BoidDetails() {
  const { t, i18n } = useTranslation();
  const toast = useToast();
  const data = useSelector((state) => state.routerData.scratchData);
  const hasBoid = useSelector((state) => state.boidDetails.hasBoid);
  const createBoid = useSelector((state) => state.boidDetails.createBoid);
  const createMeroShareId = useSelector((state) => state.boidDetails.createMeroShareId);
  const boidlist = useSelector((state) => state.boidDetails.boidList) || [];
  const forwardedBoid = useSelector((state) => state.boidDetails.forwardedBoid);
  const fdpId = useSelector((state) => state.boidDetails.fdpId);
  const duplicateData = useSelector((state) => state.routerData.duplicateData);
  const [boid, setBoid] = useState();
  const dispatch = useDispatch();
  const [dpIdDesc, setDpIdDesc] = useState();
  const [dpId, setDpId] = useState();
  const [organizationList, setOrganizationList] = useState([]);
  const [loadingf, setLoadingf] = useState(false);
  const [selectedDp, setSelectedDp] = useState();
  // const boidDetailsError = useSelector(
  //   (state) => state.boidDetails.boidDetailsError
  // );
  let boidDetailsError = "";
  const errorObj = useSelector((state) => state.boidDetails.errors);
  if (errorObj && errorObj.boidDetailsError) {
    boidDetailsError = errorObj.boidDetailsError.message;
  }

  const history = useHistory();
  const resetData = () => {
    setBoid("");
    setDpId("");
  };

  useEffect(() => {
    setLoadingf(true);
    ApiService.getDpList().then((response) => {
      setOrganizationList(response.data.data);
    }).finally(() => setLoadingf(false));
  }, []);

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const convertDate = (oDate) => {
    if (!oDate) return "";
    let date = new Date(oDate);
    let yyyy = date.getFullYear();
    let mm = ("0" + (date.getMonth() + 1)).slice(-2);
    let dd = ("0" + date.getDate()).slice(-2);
    let formattedDate = yyyy + "-" + mm + "-" + dd;
    return formattedDate;
  };

  const customerId = useSelector((state) => state.routerData.customerId);
  const formType = useSelector((state) => state.routerData.formType);
  const [validingBoid, setValidingBoid] = useState(false);
  const [resFromOldDb, setResFromOldDb] = useState();
  const [responseMessage, setResponseMessage] = useState();
  const [dpErrorMsg, setDpErrorMsg] = useState();
  const [reloadDuplicateData, setReloadDuplicateData] = useState(1);
  const firstName = useSelector((state) => state.personalDetails.firstName);
  const lastName = useSelector((state) => state.personalDetails.lastName);
  const middleName = useSelector((state) => state.personalDetails.middleName);
  const companyName = useSelector((state) => state.companyDetails.companyName);
  const registrationNo = useSelector(
    (state) => state.companyDetails.registrationNo
  );
  const panVatRegistrationNo = useSelector((state) => state.companyDetails.panVatRegistrationNo);
  const name = formType === 'I' ? firstName + " " + (middleName ? middleName + " " : "") + lastName : companyName;


  const dob = useSelector((state) => state.personalDetails.dob);
  const isMinor = useSelector((state) => state.personalDetails.isMinor);
  const documentForMinor = useSelector((state) => state.personalDetails.documentForMinor);
  const relativeList = useSelector((state) => state.familyDetails.relativeList);
  const grandFatherData = relativeList.find((p) => p.relativeTypeId == "GF");
  const fatherData = relativeList.find((p) => p.relativeTypeId == "F");
  const documentList = useSelector(
    (state) => state.documentDetails.documentList
  );

  const citizenship = documentList && documentList.find((p) => isMinor && documentForMinor === 'BC' ? p.documentTypeId === "BC" : p.documentTypeId === "CZ");
  const citizenshipNo = citizenship && citizenship.docId;
  // const ctznDistrict = citizenship && citizenship.issuedFrom;
  // const ctznIssuedDate = citizenship && citizenship.issuedDate;
  // const ctznYear = ctznIssuedDate && convertDate(ctznIssuedDate).split("-")[0];

  const grandFatherName =
    grandFatherData &&
    grandFatherData.firstName +
    " " +
    (grandFatherData.middleName ? grandFatherData.middleName + " " : "") +
    grandFatherData.lastName;
  const fatherName =
    fatherData &&
    fatherData.firstName +
    " " +
    (fatherData.middleName ? fatherData.middleName + " " : "") +
    fatherData.lastName;

  const displayConfirmModal = (param) => {
    console.log(param);
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => dispatch(removeBoid(param)),
    });
  };

  const validateAndSaveBoid = () => {
    if (!dpId) {
      setDpErrorMsg("KYC AGENT is required");
      return;
    }
    const mergedBoid = '130' + dpId + boid;
    // const mergedCitizenship = (ctznDistrict || '') + (citizenshipNo || '') + (ctznYear || '');
    setResFromOldDb("");
    setResponseMessage("");
    if (mergedBoid && mergedBoid.length == 16) {
      setValidingBoid(true);
      ApiService.checkBoidValidity(
        customerId || 0,
        [mergedBoid],
        {
          name,
          formType: formType,
          fatherName,
          grandFatherName,
          pan: panVatRegistrationNo,
          regNo: registrationNo,
          citizenshipNo: citizenshipNo || '',
          dob: dob && convertDate(dob)
        }
      ).then((response) => {
        console.log(response.data.data);
        const checkData = response.data.data[0];
        if (!checkData.exists) {
          setResFromOldDb("BOID does not exists");
          setValidingBoid(false);
        } else {
          if (checkData.matchPercentage == "100") {
            toast.success('BOID Match', "BOID matched with the KYC data");
            dispatch(addBoid({ boid, dpIdDesc, dpId, matchPerc: checkData.matchPercentage }));
            resetData();
          }
          else
            toast.error('BOID doesnot match KYC data', checkData.msg ? "(" + checkData.msg + ")" : "");

          // if (checkData.used)
          //   toast.warning("BOID is claimed", "BOID is already claimed by another KYC");


          setResFromOldDb("");
          setResponseMessage("");
        }
      }).finally(() => setValidingBoid(false));
    }
  };

  const footer = () => (
    <div class=" p-field p-col-12 p-md-12">
      <div className="p-grid" style={{ flex: 3 }}>
        <div style={{ flex: 1 }}>
          <PrevButton />
        </div>
        <div style={{ flex: 1 }}>
          <center>
            <SaveButton style={{ flex: 1 }} />
          </center>
        </div>
        <div style={{ flex: 1 }}>
          <center>
            <NextButton />
          </center>
        </div>
      </div>
    </div>
    // <div className="p-grid">
    //   <div className="p-col-12 p-md-5">
    //     <PrevButton />
    //   </div>
    //   <div className="p-col-12 p-md-2">
    //     <SaveButton />
    //   </div>
    //   <div className="p-col-12 p-md-3"></div>
    //   <div className="p-col-12 p-md-2">
    //     <NextButton />
    //   </div>
    // </div>
  );

  const labelTemplate = (options) => {
    return options.dpId === null ? options.name : options.name + "-" + options.dpId;
  }

  return (
    <Card
      className="p-col-12 p-md-12 main-card"
      header={
        <h3 className="p-col-12 p-md-12 text-center">
          <i className="pi pi-chart-bar"></i> {t("boidDetails")}
        </h3>
      }
      footer={footer}
    >
      <div className="p-grid p-fluid" style={{ margin: 0 }}>
        <h4 className="p-col-12 p-md-12">
          <p className="section-title">{t("boidDetails")}</p>
        </h4>
        <div className="p-field p-col-12 p-md-4 stick-right">
          <label className="p-col-12 p-md-12">{t("haveBoid")}*</label>

          <div className="p-field-radiobutton p-col-12 p-md-12 ">
            {/* <RadioButton name="hasBoid" inputId="hasBoidYes" value={true} onChange={e => dispatch(setHasBoid(e.value))} checked={hasBoid} /> */}
            <Controller
              name="hasBoid"
              control={control}
              //  rules={{ required: "BOID is required." }}
              render={({ field, fieldState }) => (
                <RadioButton
                  id={field.name}
                  {...field}
                  value={true}
                  onChange={(e) => {
                    dispatch(setHasBoid(e.value))
                  }}
                  checked={hasBoid}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            <label className="p-mr-5">{t("xa")}</label>
            {/* <RadioButton name="hasBoid" inputId="hasBoidNo" value={false} onChange={e => dispatch(setHasBoid(e.value))} checked={hasBoid === false} /> */}
            <Controller
              name="hasBoid"
              control={control}
              //  rules={{ required: "BOID is required." }}
              render={({ field, fieldState }) => (
                <RadioButton
                  id={field.name}
                  {...field}
                  value={false}
                  onChange={(e) => {
                    dispatch(setHasBoid(e.value))
                  }}
                  checked={hasBoid === false}
                  className={classNames({ "p-invalid": fieldState.invalid })}
                />
              )}
            />
            <label className="p-mr-5">{t("xaina")}</label>
          </div>
          <span style={{ color: "red" }}>{boidDetailsError}</span>
          {getFormErrorMessage("hasBoid")}
        </div>
        {hasBoid != null && !hasBoid && (
          <div className="p-field p-col-12 p-md-4 stick-right stick-left">
            <label className="p-col-12 p-md-12" htmlFor="forwardToDp">
              {t("forwardToDp")}*
            </label>

            <Controller
              name="forwardToDp"
              control={control}
              rules={{ required: "Forward to KYC AGENT is required." }}
              render={({ field, fieldState }) => (
                <Dropdown
                  id={field.id}
                  value={selectedDp}
                  filter showClear
                  disabled={loadingf}
                  dropdownIcon={loadingf ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                  onChange={(e) => {
                    setSelectedDp(e.value); // store whole object
                    dispatch(setFdpId(e.value?.dpId));
                    dispatch(setFdpIdDesc(e.value?.name));
                    dispatch(setCreateBoid(null));
                    dispatch(setCreateMeroShareId(null));
                  }}
                  options={organizationList}
                  optionLabel={labelTemplate}
                  placeholder={t("selectDp")}
                // optionValue="dpId"
                />
              )}
            />
          </div>
        )}
        {selectedDp && selectedDp.showCreateBoid != false &&
          <div className="p-field p-col-12 p-md-4  stick-left">
            <label className="p-col-12 p-md-12">{t("createBoid")}</label>
            <div className="p-field-radiobutton p-col-12 p-md-12 ">
              {/* <RadioButton name="createBoid" inputId="createBoidYes" value={true} onChange={e => dispatch(setCreateBoid(e.value))} checked={createBoid} /> */}

              <RadioButton
                name="createBoid"
                value={true}
                onChange={(e) => dispatch(setCreateBoid(e.value))}
                checked={createBoid === true}
              />
              <label className="p-mr-5">{t("hunxa")}</label>
              {/* <RadioButton name="createBoid" inputId="createBoidNo" value={false} onChange={e => dispatch(setCreateBoid(e.value))} checked={!createBoid} /> */}

              <RadioButton
                name="createBoid"
                value={false}
                onChange={(e) => dispatch(setCreateBoid(e.value))}
                checked={createBoid === false}
              />
              <label className="p-mr-5">{t("hudaina")}</label>
            </div>
          </div>
        }

        {selectedDp && selectedDp.showCreateBoid != false && createBoid && (
          <div className="p-field p-col-12 p-md-4 stick-left">
            <label className="p-col-12 p-md-12">{t("createMeroShareId")}</label>
            <div className="p-field-radiobutton p-col-12 p-md-12">
              <RadioButton
                name="createMeroShareId"
                value={true}
                onChange={(e) => {

                  // console.log('checkcreateMeroShareIdYes>>>>>>>>>>>>', e);
                  dispatch(setCreateMeroShareId(e.value));
                }}
                checked={createMeroShareId === true}
              />
              <label className="p-mr-5">{t("yes")}</label>

              <RadioButton
                name="createMeroShareId"
                value={false}
                onChange={(e) => {
                  console.log('checkcreateMeroShareIdNo>>>>>>>>>>>>', e);
                  dispatch(setCreateMeroShareId(e.value));
                }}
                checked={createMeroShareId === false}
              />
              <label className="p-mr-5">{t("no")}</label>
            </div>
          </div>
        )}

        {hasBoid != null && hasBoid && (
          <div className="p-col-12 p-md-12">
            <div className="p-grid">
              <div className="p-col-12 p-md-5 p-pr-0 stick-right">
                <Controller
                  name="forwardToDp"
                  control={control}
                  rules={{ required: "KYC AGENT is required." }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      id={field.id}
                      value={dpId}
                      filter showClear
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        setDpId(e.target.value);
                        setDpIdDesc(
                          e.originalEvent.nativeEvent.target.ariaLabel
                        );
                        setDpErrorMsg("");
                      }}
                      options={organizationList}
                      optionLabel={labelTemplate}
                      placeholder={t("selectDp")}
                      optionValue="dpId"
                    />
                  )}
                />
                {getFormErrorMessage("forwardToDp")}
              </div>

              <div className="p-col-12 p-md-5 p-pl-0s stick-left">
                {/* <InputText placeholder={t("boid")} value={boid} onChange={e => setBoid(e.target.value)} />  */}
                <Controller
                  name="boid"
                  control={control}
                  rules={{ required: "BOID is required." }}
                  render={({ field, fieldState }) => (
                    <InputMask
                      mask={'130' + (dpId ? dpId : '00000') + "99999999"}
                      autoClear={false}
                      id={field.name}
                      {...field}
                      placeholder={t("boid")}
                      onChange={(e) => {
                        const value = e.target.value && e.target.value.substring(8);
                        setBoid(value);
                        field.onChange(value);
                      }}
                      onBlur={(e) => {
                        const value = e.target.value && e.target.value.substring(8);
                        if (value && value.includes("_")) {
                          const value2 = ("00000000" + value.replaceAll(/_/g, '')).slice(-8);
                          setBoid(value2);
                          field.onChange(value2);
                        }
                      }}
                      value={'130' + (dpId ? dpId : '00000') + boid}
                      className={classNames({
                        "p-invalid": fieldState.invalid,
                      })}
                    />
                  )}
                />
                {getFormErrorMessage("boid")}
                <small className="p-error">
                  {[dpErrorMsg, resFromOldDb, responseMessage].filter(d => d).join(', ')}
                </small>
              </div>

              <div className="p-col-12 p-md-2">
                <Button
                  className="add-button"
                  loading={validingBoid}
                  onClick={handleSubmit((e) => {
                    const checkBoid = boidlist.find(
                      (p) => p.boid == boid && p.dpId == dpId
                    );
                    if (checkBoid) {
                      toast.error("Message", "BOID already exists");
                      return;
                    } else {
                      validateAndSaveBoid()
                    }
                  })}
                  style={{ textAlign: "center" }}
                >
                  <i className="pi pi-plus"> Add</i>{" "}
                </Button>
              </div>
            </div>

            {boid && boid.length != 8 && (
              <span style={{ color: "#f55", padding: 5 }}>
                BOID must be 8 digit
              </span>
            )}
            {getFormErrorMessage("forwardToDp")}

            <DataTable value={boidlist} dataKey="boid">
              <Column field="fullBoId" header={t("boid")}
                body={(rd) => {
                  return (
                    rd.fullBoId ? rd.fullBoId : rd.boid
                  );
                }}
              ></Column>
              <Column
                header={t("dpIdDesc")}
                body={(rd) => {
                  return (
                    (
                      (organizationList &&
                        organizationList.find((o) => o.dpId == rd.dpId)) ||
                      {}
                    ).name || rd.dpId
                  );
                }}
              ></Column>
              <Column
                header={t("forward")}
                body={(rowData) => (
                  <Checkbox
                    inputId={"forwardedBoid" + rowData.boid}
                    name="forwardedBoid"
                    checked={rowData.isForwarded}
                    onChange={(e) =>
                      dispatch(setForwardBoid(rowData.dpId + rowData.boid))
                    }
                  />
                )}
              ></Column>
              <Column
                header={t("action")}
                body={(rowData) => (
                  <i
                    className="pi pi-trash"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      // dispatch(removeBoid(rowData.dpId + rowData.boid))
                      displayConfirmModal(rowData.dpId + rowData.boid)
                    }
                  />
                )}
              ></Column>
            </DataTable>
          </div>
        )}

        <DynamicFieldSection />
      </div>



      <SaveButton style={{ flex: 1 }} extraData={"instantAnalysis"} onReload={() => { setReloadDuplicateData(prev => prev + 1) }} />
      {data && (data.personDetail || data.companyDetail) && duplicateData &&
        <KycInfoForPublic {...data} reloadDuplicateData={reloadDuplicateData} duplicateData={duplicateData} />
      }
    </Card>
  );
}

export default BoidDetails;
